import {CROPPED_PICTURE} from '../actions/FileUploadActions';

export const defaultState = {};

export default function fileUpload(state = defaultState, action)
{
    switch (action.type) {
        case 'CROPPED_PICTURE':
            return {...state, data: action.payload};
        default:
            return state;
    }
}
